module.exports = __webpack_public_path__ + "static/media/tokyo.53595588.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/tokyo.jpeg
// module id = 300
// module chunks = 0